import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, ButtonDropdown, FormField, Link, Modal, Popover, Select, SpaceBetween, StatusIndicator, Table } from '@cloudscape-design/components';

import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiCheckUnderlineCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { differenceInDays, parse } from 'date-fns';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemFlight } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, minutesToHHMM2, setData, setLoading } from '../../../../commons/functions';

export const MembersEDVCoursesPage = () => {
    const { menu, parameters } = useGlobalState();
    const [students, setStudents] = useState<any[]>([])
    const [student, setStudent] = useState<any>(null)
    const [DGAC, setDGAC] = useState<any[]>([]);
    const [START, setSTART] = useState<any[]>([]);
    const [flights, setFlights] = useState<ItemFlight[]>([]);




    const handleGetStudents = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/instruction/courses',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.students) {
                setStudents(data.students)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleGetStudents();
    }, [parameters.year]);



    const handleGetFlights = async (user: any) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "idFlight, registration, departureDate, arrivalDate, flightType, delta, userInstructor",
                    dateStart: user?.dateStart,
                    ...(user?.dateLicence && { dateEnd: user.dateLicence }),
                    idUser: user.idUser,
                    groupTypeMasterCode: user.licenceType,
                    idFlightTypes: [1135, 2799],
                    order: "asc",
                    orderBy: "departureDate",
                })
            });

            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.flights) {

                const indexedFlights = data.flights.map((item: any, index: number) => ({
                    ...item,
                    // Add a new property to the item object
                    index: index + 1
                }));
                setFlights(indexedFlights)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleGetExams = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "departureDate, idFlight, registration, departureDate, arrivalDate, departureArrivalDelta, flightType",
                    idFlightType: 2799,
                    idUserPilot: student.idUser,
                    groupTypeMasterCode: student.licenceType
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.flights) {
                setDGAC(data.flights.map((f: any) => ({

                    text: f.registration,
                    id: f.departureDate + "." + f.idFlight,
                    secondaryText: f.departureDate,
                    labelTag: minutesToHHMM2(f.departureArrivalDelta)
                })))
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleFirstFlight = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    columns: "departureDate, idFlight, registration, departureDate, arrivalDate, departureArrivalDelta, flightType",
                    idFlightType: 1135,
                    idUserPilot: student.idUser,
                    groupTypeMasterCode: student.licenceType,
                    orderBy: "arrivalDate",
                    order: "ASC",
                    limit: 1
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.flights) {
                setSTART(data.flights.map((f: any) => ({
                    text: f.registration,
                    id: f.departureDate + "." + f.idFlight,
                    secondaryText: f.departureDate,
                    labelTag: minutesToHHMM2(f.departureArrivalDelta)
                })))
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (student && student.licenceType && student.licenceType !== "" && student.idUser && student.idUser > 0) {
            handleGetExams();
            handleFirstFlight();
        }
    }, [student?.idUser, student?.licenceType]);
    const handleUpdateStudent = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/edv/students/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(student)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data.code === 0) {
                addNotification(data.status, "success", setData)
                handleGetStudents();
                setStudent(null);
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <>
                            <Favorites /></>}>
                        Mis cursos</Header>
                    <Table
                        stickyHeader
                        variant='embedded'
                        columnDefinitions={[
                            { id: 'instructor', header: 'Instructor', cell: item => <FormField label={item.instructor} /> },
                            { id: 'course', header: 'Curso', cell: item => item?.licenceType },
                            { id: 'start', header: 'Inicio/Término', cell: item => <FormField label={item.dateStart}>{item?.dateLicence === "" ? <Link onClick={() => setStudent(item)}><StatusIndicator type="pending">Pendiente</StatusIndicator></Link> : <StatusIndicator type="success">{item.dateLicence}</StatusIndicator>}</FormField> },
                            {
                                id: 'solo', header: 'Solo', width: 50, cell: item => item?.dateSolo !== "" ?
                                    <Popover dismissButton={false} triggerType="custom"
                                        content={<>{item.dateSolo}, {differenceInDays(parse(item.dateSolo, "dd-MM-yyyy", new Date()), parse(item.dateStart, "dd-MM-yyyy", new Date()))} días</>}
                                        dismissAriaLabel="Close popover" header="Fecha de primer vuelo solo">
                                        <Icon path={mdiCheckUnderlineCircle} size={1} color={"green"} />
                                    </Popover> : ""
                            },
                            { id: 'end', header: 'Totales', cell: item => <Link onClick={() => { handleGetFlights(item) }}>{item?.TotalFlights || 0}Vº {minutesToHHMM2(item?.TotalTime) || 0}</Link> },
                            {
                                id: 'erxt', header: 'Avance', cell: item => <>{Math.round(item.TotalFlights / 50 * 100)}% {Math.round(item.TotalFlights / 50 * 100) > 100 ? <Icon path={mdiAlert} size={1} color={"red"} /> :
                                    Math.round(item.TotalFlights / 50 * 100) > 85 ? <Icon path={mdiAlert} size={1} color={"orange"} /> :
                                        ""}</>

                            },
                        ]}
                        items={students}
                        loadingText="Cargando alumnos..."
                    />

                    <Modal size="small" onDismiss={() => setStudent(null)} visible={student !== null} closeAriaLabel="Cerrar modal de alumno"
                        header={<Header variant="h2" description={`${student?.displayName}`}>{student?.idUserStudent && student.idUserStudent > 0 ? `Editar alumno ` : "Agregar nuevo alumno"}</Header>}
                        footer={

                            <Box>
                                <Box float="left">
                                    <Button variant="link" onClick={() => setStudent(null)}>Cancelar</Button></Box>
                                <Box float="right">
                                    <Button variant="primary" onClick={() => handleUpdateStudent()}
                                        disabled={!student || student.idUser === 0
                                            || !student.licenceType || student.licenceType === ""
                                            || !student.dateStart || student.dateStart === ""
                                            || !student.idUser || student.idUser === 0
                                            || !student.idInstructor || student.idInstructor === 0
                                        }
                                    >{student && student.idUserStudent === 0 ? "Ingresar" : "Actualizar"}</Button></Box>

                            </Box>
                        }
                    >
                        <SpaceBetween size="s" direction='vertical'>
                            <FormField label="Tipo de curso">
                                <Select options={[{ label: "Planeador", value: "GLIDER" }, { label: "Avión", value: "PLANE" }]}
                                    selectedOption={student ? { label: student.licenceType, value: student.licenceType } : null}
                                    onChange={({ detail }) => {
                                        if (!student) return;
                                        setStudent({ ...student, licenceType: detail.selectedOption.value })

                                    }}
                                />
                            </FormField>
                            {student && student.licenceType && student.licenceType !== "" && (
                                <>
                                    <FormField label="Alumno">
                                        <SelectUser onConfirm={(user) => {
                                            if (user)
                                                setStudent({ ...student, idUser: user.idUser })
                                        }}
                                            value={student ? student.idUser || 0 : 0}
                                        />
                                    </FormField>
                                    <FormField label="Instructor">
                                        <SelectUser
                                            filter={`INSTRUCTOR.${student.licenceType}`}
                                            onConfirm={(user) => {
                                                if (user)
                                                    setStudent({ ...student, idInstructor: user.idUser })
                                            }}
                                            value={student ? student.idInstructor || 0 : 0}
                                        />
                                    </FormField>
                                    <FormField label="Fecha inicio" info={
                                        START && START.length > 0 && (<Link
                                            onClick={() => {
                                                setStudent({ ...student, dateStart: START[0]?.secondaryText })

                                            }}
                                        >{START[0]?.secondaryText}-{START[0].text}</Link>)
                                    }>
                                        <DPModal date={student ? student.dateStart || "" : ""} onConfirm={(date) => {
                                            if (!student) return;
                                            setStudent({ ...student, dateStart: date })
                                        }} />

                                    </FormField>
                                    <FormField label={
                                        <SpaceBetween direction='horizontal' size='xs'>
                                            <span>Fecha de licencia</span>
                                            {DGAC && DGAC.length > 0 && (
                                                <ButtonDropdown
                                                    items={DGAC}
                                                    ariaLabel="Control instance"
                                                    variant="inline-icon"
                                                    onItemClick={(e) => {
                                                        setStudent({ ...student, dateLicence: e.detail.id.split(".")[0] })
                                                    }}
                                                />)}
                                        </SpaceBetween>
                                    }>
                                        <DPModal date={student ? student.dateLicence || "" : ""} onConfirm={(date) => {
                                            if (!student) return;
                                            setStudent({ ...student, dateLicence: date })
                                        }} />

                                    </FormField>
                                </>
                            )}
                        </SpaceBetween>
                    </Modal >
                    <Modal size='large' visible={flights.length > 0} onDismiss={() => setFlights([])} closeAriaLabel="Close modal" header={`Vuelos de ${student?.displayName}`}>
                        <Table
                            variant="borderless"
                            stickyHeader
                            cellVerticalAlign='top'
                            columnDefinitions={[
                                { id: 'index', header: '', cell: item => item?.index, width: 30 },
                                { id: 'registration', header: 'Matrícula', cell: item => <FormField label={item?.registration}>{item?.userInstructor}</FormField> },
                                { id: 'departureDate', header: 'Fecha', cell: item => item?.departureDate },
                                { id: 'flightType', header: 'Tipo Vuelo', cell: item => item?.flightType },
                                { id: 'departureArrivalDelta', header: 'Duración', cell: item => minutesToHHMM2(item?.delta ?? 0) },
                            ]}
                            items={flights}
                            loadingText="Cargando vuelos..."
                        />
                    </Modal>
                </SpaceBetween >
            }
        />
    )
};
